module.exports = __webpack_public_path__ + "img/bg-logo2.6c3cde7d.png";